import back5 from "../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import Nav from "../../vendor/navbar";
import Main from "./main";
// import Filters from "../filters/newFilter";

// import Table from "../table";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
const Listing = () => {
  const router = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  useEffect(() => {
    dispatch({ type: "QUOTATION_FLOW", num: false });
    dispatch({ type: "SELECTED_VENDORS", num: [] });
    dispatch({
      type: "SELECTED_PAYMENT_TERM",
      num: null,
    });
    dispatch({ type: "ORDER_DATA", num: null });
  }, []);

  return (
    <div className="bg-[#D9EFED] min-h-screen h-screen">
      <Nav />
      <div className="flex items-center justify-center bg-[#D9EFED] ">
        <div className="sm:w-[95%] w-full sm:px-10 px-6 rounded-md mb-12">
          <div className="cursor-pointer flex w-full items-center justify-center mt-3">
            <img
              onClick={() => {
                if (user === "vendor-owner") {
                  router("/VendorDashboard");
                  return;
                }
                router("/SuperAdmin/InventoryDashboard");
              }}
              className="sm:w-[1.7rem] w-[1.3rem]"
              src={back5}
              alt=""
            />
            <h2 className="font-bold w-full sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
              Place Order
            </h2>
          </div>
          {/* <Filters /> */}
          <div className="rounded-md sm:p-2">
            <Main />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listing;
